
function Check({ color = "#000", size = 16 }) {
	return (
		<svg height={size} width={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
			<g fill={color}>
				<path
					d="M6,15a1,1,0,0,1-.707-.293l-5-5A1,1,0,1,1,1.707,8.293L5.86,12.445,14.178.431a1,1,0,1,1,1.644,1.138l-9,13A1,1,0,0,1,6.09,15C6.06,15,6.03,15,6,15Z"
					fill={color}
				/>
			</g>
		</svg>
	);
}

export default Check;
